// Components==============
import React from 'react';
import './Label.module.scss';
// =========================
type Type = 'blue' | 'white' | 'grey' | 'outline';
type Size = 'small' | 'large';

type Props = {
  type?: Type;
  size?: Size;
  children: React.ReactNode;
};

export default function Label({
  type = 'blue',
  size = 'small',
  children,
}: Props) {
  return <label styleName={`label ${type} ${size}`}>{children}</label>;
}
